import React from 'react'

import HeaderMeta from 'components/HeaderMeta'

import Content from 'components/base/Content'
import Title from 'components/base/Title'
import ButtonRow, { Theme as ButtonRowTheme } from 'components/base/Button/Row'
import Button from 'components/base/Button'
import Form from 'components/base/Form'
import Input, { Type as InputType } from 'components/base/Form/Input'
import InputGroup from 'components/base/Form/InputGroup'
import Tooltip from 'components/blocks/Tooltip'
import ModalForgetMe from 'components/blocks/Modal/ForgetMe'
import UserSuppliedText from 'components/base/UserSuppliedText'

import QuotingWrapper, { Theme as QuotingWrapperTheme } from 'components/blocks/QuotingWrapper'

import {
  events,
  useGoogleTagManager,
} from 'hooks/useGoogleTagManager'

import { CheckboxWithTooltip } from './styles'

import { Props } from './types'

const QuotingStart: React.FC<Props> = ({
  applicantFirstName,
  applicantLastName,
  showInputs,
  onClickContinue,
  onClickReset,
  onForgetMeConfirm,
}): React.ReactElement => {
  const { pushDataLayerEvent } = useGoogleTagManager()

  return (
    <QuotingWrapper noPadding={true} theme={QuotingWrapperTheme.concierge} title='Hi!'>
      <HeaderMeta
        title='Get An Insurance Quote Online | Insurance Lounge'
        description='Get your home, auto, life, health, or other insurance policy quote online in seconds with our convenient online quote tool!'
      />
      {(showInputs && (
        <>
          <Title level={3}>
            I’m your personal Insurance Concierge.<sup>®</sup> I’ll get you an
            awesome price in minutes. Ready?
          </Title>
          <Content margined={true}>
            <Form
              short={true}
              nextUrl='quote/new/zip'
              onSubmit={() => pushDataLayerEvent(events.quote_form_started)}
            >
              <InputGroup
                type={InputType.text}
                label='First Name'
                name='firstName'
                quoteRequestField='applicant.personalInfo.name.firstName'
                rules="required|string:maxLength=64|match:pattern=^[A-Za-z]{1}[\-' A-Za-z]*$"
              />
              <CheckboxWithTooltip>
                <Input
                  type={InputType.checkbox}
                  aria-label='I am on a public computer'
                  name='isPublicComputer'
                  quoteRequestField='isPublicComputer'
                >
                  I am on a public computer.
                </Input>
                <Tooltip>
                  Select &quot;I am on a public computer&quot; if you are on a shared computer and wish to have your quote entries automatically forgotten when you close this window. If you are on your own computer leave it unchecked for an enhanced experience.
                </Tooltip>
              </CheckboxWithTooltip>

              <ButtonRow>
                <Button center={true} wide={true} isQuoteRequestNext={true}>
                  Let‘s Get Going
                </Button>
              </ButtonRow>
            </Form>
          </Content>
        </>
      )) || (
        <>
          <Content margined={true}>
            <ButtonRow theme={ButtonRowTheme.stacked}>
              <Button
                center={true}
                wider={true}
                onClick={onClickContinue}
              >
                Continue as<br /><UserSuppliedText>{((applicantFirstName || applicantLastName) && `${applicantFirstName || ''}${(applicantFirstName && applicantLastName && ' ') || ''}${applicantLastName || ''}`) || 'current user'}</UserSuppliedText>
              </Button>
              <Button
                center={true}
                wider={true}
                secondary={true}
                onClick={onClickReset}
              >
                Forget My Info<br />&amp; Start Over
              </Button>
            </ButtonRow>
          </Content>

          <ModalForgetMe onConfirm={onForgetMeConfirm} />
        </>
      )}

    </QuotingWrapper>
  )
}

export default QuotingStart
